export default ['date', 'number', 'string', 'boolean'];

/**
 * Подписи типов значения для выпадающих списков. Сами коды уходят на сервер как есть,
 * а человеку показывать «number» и «boolean» незачем.
 */
export const InventoryAttributeValueTypeTitles = {
    date: 'Дата',
    number: 'Число',
    string: 'Строка',
    boolean: 'Да / нет',
};

export function inventoryAttributeValueTypeTitle(type) {
    return InventoryAttributeValueTypeTitles[type] ?? String(type ?? '');
}
